import { Button, CircularProgress, Dialog } from '@material-ui/core';
import { History } from 'history';
import { useEffect, useRef, useState } from 'react';
import { connect, useDispatch, useSelector } from 'react-redux';
import { useHistory } from 'react-router';
import { getKycRegistrationLink } from '../../redux-store/actions/commercialTransactions';
import { RootStateType } from '../../redux-store/reducers';
import { SET_KYC_REGISTRATION_POPUP } from '../../redux-store/types/portfolio';
import { isMobileDevice } from '../../utils/constants';
import { handleRedirectOnMobile } from '../../utils/utilityFunctions';
import { CommercialRootPath } from '../dashboard/commercial/routeConfig';
import { $wait } from '../dashboard/commercial/utils';

type KYCProps = {
    getKycRegistrationLink: Function;
}

enum KycRegStatus {
    initial = 0,
    success = 1,
    failure = 2
}

function KYCRegisterPopup(props: KYCProps) {
    const history = useHistory();

    // const [shouldRegister,setShouldRegister] = useState(false)
    const [redirecting, setRedirecting] = useState(false);

    // const [registrationStatus,setRegistrationStatus] = useState<KycRegStatus>(KycRegStatus.initial)
    const kycRegistrationPopup = useSelector(
        (state: RootStateType) => state.newPurchase.kycRegistrationPopup,
    );

    const dispatch = useDispatch();

    function hideThisPopup() {
        dispatch({
            type: SET_KYC_REGISTRATION_POPUP,
            body: { kycRegistrationPopup: null },
        });
    }
    function redirectionFailed() {
        // setRegistrationStatus(KycRegStatus.failure)
        alert('Failed to redirect');
    }

    function handleOpeningOfRedirectionUrl(redirectionUrl: string) {
        if (isMobileDevice()) {
            handleRedirectOnMobile({
                url: redirectionUrl,
                history,
                redirectionPage: 'kyc-status',
            });
        } else {
            console.log(redirectionUrl);
            window.open(redirectionUrl, '_self');
        }
    }

    async function handleRedirectToKycRegistration() {
        try {
            setRedirecting(true);
            const isin = kycRegistrationPopup?.isin || '';
            const amc = kycRegistrationPopup?.amc || '';

            const resp = await props.getKycRegistrationLink({ amc, isin });

            // await $wait(1200);
            console.log(resp.body.redirectUrl, resp);

            const redirectionUrl = resp?.body?.redirectUrl || '';

            handleOpeningOfRedirectionUrl(redirectionUrl);
            // setRegistrationStatus(KycRegStatus.success)
        } catch (error) {
            redirectionFailed();
        } finally {
            setRedirecting(false);
            hideThisPopup();
        }
    }

    if (!kycRegistrationPopup) {
        return null;
    }

    if (redirecting) {
        return (
            <Dialog maxWidth={'sm'} open={redirecting} aria-labelledby="enable-fingerprint-modal">
                <div className="enable-fingerprint-modal">
                    <CircularProgress />
                    <p style={{ marginTop: '16px' }}>{'Redirecting to KYC registration...'}</p>
                </div>
            </Dialog>
        );
    }

    return (
        <Dialog maxWidth={'sm'} open={true} aria-labelledby="note-modals">
            <div className="note-modals">
                <h3> {`KYC not registered`}</h3>
                <p>Please click continue to register through eKYC.</p>

                <div className="note-modals-btns">
                    <Button className="customBtn cancelBtn" onClick={hideThisPopup}>
                        Cancel
                    </Button>
                    <Button className="customBtn" onClick={handleRedirectToKycRegistration}>
                        Continue
                    </Button>
                </div>
            </div>
        </Dialog>
    );
}


export default connect(null, {
    getKycRegistrationLink,
})(KYCRegisterPopup);
